import React, { Component } from 'react';
import '../styles/Home.css';

 
export class CallBack extends Component {
   
    constructor(props) {
        super(props);
 
    }

    componentDidMount() {
      
    }
   

    render() {
        
  
        return (
            <div>test
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CallBack.jsx